<tidy-card>
  <tidy-row class="vertical-align-center extra-bottom-padding">
    <tidy-image
      [src]="'assets/img/complete.svg'"
      class="title-size" />
    <tidy-text
      [header]="'Maintenance Plans'" />
  </tidy-row>
  @for (maintenance of itemMaintenances | slice:0:showLimiter['itemMaintenances']; track maintenance) {
    <tidy-row>
      <tidy-text
        [body]="maintenance?.name" /><br>
      <tidy-text
        [helper]="maintenance?.next_do_date  | parseDateTime: 'MMM d'" />
    </tidy-row>
  }
  @if (itemMaintenances.length > 3) {
    <tidy-card-button (action)="showLimit('itemMaintenances')">
      <tidy-row>
        <tidy-text
          [body]="('Show ' | translate) + (showLimiter['itemMaintenances'] == 3 ? ('more' | translate) : ('less' | translate)) + (' maintenances' | translate)" />
      </tidy-row>
    </tidy-card-button>
  }
  @if (itemMaintenances.length === 0) {
    <tidy-row >
      <tidy-text
        [helper]="'No maintenance plans'" />
    </tidy-row>
  }
</tidy-card>
